/* eslint-disable no-debugger */
/* eslint-disable no-extra-semi */
import { useEffect } from 'react';
import useRecordTimesData from '../../../state/recordTimesAdmin/UseRecordTimesData';
import useRecordsData from '../../../state/recordsAdmin/UseRecordsData';

import useForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import useRecordAgeGroupData from '../../../state/recordAgeGroup/UseRecordAgeGroupData';

import validate from './RecordsAdminListInstanceDetailValidation';
import NavLinks from '../NavLinks';

const competitionGenderTypeOptions = [
  { id: Constants.DEFAULT_ID, name: "--" },
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
  { id: 3, name: "Mixed (Relay Only)" }];

const useRecordsAdminListInstanceDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { recordTimesState } = useRecordTimesData();
  const { recordsState, postRecordListInstanceReturnArray } = useRecordsData();

  const { recordAgeGroupState, getRecordAgeGroups } = useRecordAgeGroupData();
  const { errorState, setErrors, formState, handleSubmit, onValueTextPairChanged, onFormValueChanged } = useForm(getInitialFormState, submitFormCallback, validate);

  function submitFormCallback(formState) {
    const recordListIndex = recordsState.arrayData.findIndex(x => x.recordListId === location.state.recordListId);
    
    let valPos = recordsState.arrayData[recordListIndex].recordEvents.findIndex(
      x => x.eventId === formState.eventId &&
        x.eventCompetitionGenderTypeId === formState.eventCompetitionGenderTypeId &&
        x.recordAgeGroupId === formState.recordAgeGroupId);

    if (valPos !== -1) {
      setErrors({ ...errorState, duplicateRecords: "This event already exists. If you don't see it in the list you may need to adjust your filter settings." });
    } else {
      postRecordListInstanceReturnArray({
        recordGroupId: location.state.recordGroupId,
        recordListId: location.state.recordListId,
        orgUnitId: 0, //location.state.orgUnitId,
        eventId: formState.eventId,
        eventCompetitionGenderTypeId: formState.eventCompetitionGenderTypeId,
        recordAgeGroupId: formState.recordAgeGroupId
      });
    }
  }

  const onCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.RECORDS_EVENTS, {
      state: {
        recordGroupId: location.state.recordGroupId,
        recordListId: location.state.recordListId,
        paramRecordListId: location.state.paramRecordListId,
        recordListName: location.state.recordListName,
        orgUnitId: location.state.orgUnitId,
        backFromActionPage: true,
        filterRecordAgeGroupId: location.state.filterRecordAgeGroupId,
        filterEventId: location.state.filterEventId,
        filterEventCompetitionGenderTypeId: location.state.filterEventCompetitionGenderTypeId,
        filterCourseId: location.state.filterCourseId
      }
    });
  }

  useEffect(() => {
    if (recordsState.isSaved === true) {
      navigate(NavLinks.RECORDS_EVENTS, {
        state: {
          recordGroupId: location.state.recordGroupId,
          recordListId: location.state.recordListId,
          paramRecordListId: location.state.paramRecordListId,
          recordListName: location.state.recordListName,
          orgUnitId: location.state.orgUnitId,
          backFromActionPage: true,
          filterRecordAgeGroupId: location.state.filterRecordAgeGroupId,
          filterEventId: location.state.filterEventId,
          filterEventCompetitionGenderTypeId: location.state.filterEventCompetitionGenderTypeId,
          filterCourseId: location.state.filterCourseId
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordsState]);

  useEffect(() => {
    if (recordAgeGroupState.isArrayLoaded === false && recordAgeGroupState.isArrayLoading === false) {
      getRecordAgeGroups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getInitialFormState() {
    return {
      recordListInstanceId: Constants.DEFAULT_ID,
      eventId: Constants.DEFAULT_ID,
      eventName: '',
      eventCompetitionGenderTypeId: competitionGenderTypeOptions[0].id,
      competitionGenderTypeName: competitionGenderTypeOptions[0].name,
      recordAgeGroupId: Constants.DEFAULT_ID,
      courseId: Constants.DEFAULT_ID,
      ageGroupDesc: '',
      threshold: ''
    };
  };

  return {
    recordsState,
    recordTimesState,
    formState,
    errorState,
    recordAgeGroupState,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    onCancelClicked,
    competitionGenderTypeOptions
  }
}

export default useRecordsAdminListInstanceDetail;